<template>
  <div></div>
</template>

<script>
import Axios from 'axios'
import { deleteCookie } from '@/cookiesHandler'

export default {
  name: 'logout',
  mounted () {
    deleteCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00')
    this.$store.commit('LOGOUT_USER')
    this.$router.push('login')
  }
}
</script>
